import httpService from './httpService';

import * as models from '../utils/models';

function createRole(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post('/role/create-role', data, { onUploadProgress });
}

function deleteRole(roleId: string) {
	return httpService.delete('/role/' + roleId);
}

function editRole(
	roleId: string,
	data: any,
	onUploadProgress: models.ProgressChange
) {
	return httpService.put('/role/' + roleId, data, { onUploadProgress });
}

function getAllRoles() {
	return httpService.get('/role');
}

function getRole(roleId: string) {
	return httpService.get('/role/' + roleId);
}

export { createRole, deleteRole, editRole, getAllRoles, getRole };
